export default __webpack_public_path__ + "src/_images/L250.png";